/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AgreementWithCredits } from '../models/AgreementWithCredits';

/**
* Response containing agreements and refunds with credit information
*/
export class GetAgreementsResponse {
  /**
  * List of agreements and refunds with credit details.
  */
  'agreements': Array<AgreementWithCredits>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "agreements",
      "baseName": "agreements",
      "type": "Array<AgreementWithCredits>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetAgreementsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

